import React from "react";

import URI from "urijs";

import { Label } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import type { CurrencyCode } from "@app/types/currency";

import {
  currency_codes as all_currencies,
  popular_currencies
} from "../../../../../config/currencies";
import { CurrencyIconMD } from "../../../currency-icon";
import { CustomNativeSelect } from "../../../custom-native-select";

export const PickerCurrency: React.FC = () => {
  const { intlProvider, translator, urlBuilder } = useAppContext();

  const less_popular_currencies = all_currencies.filter(
    currency => !popular_currencies.includes(currency)
  );
  const sorted_currencies = [...popular_currencies, ...less_popular_currencies];

  const current_url = urlBuilder.currentUrl();
  const makeLink = (cur: CurrencyCode) =>
    new URI(current_url).setQuery("currency", cur).href();

  return (
    <div className="-my-050 mx-0">
      <CustomNativeSelect
        defaultValue={makeLink(intlProvider.currency)}
        data-interactive="redirection"
        id="currency-picker"
        Trigger={
          <Label
            as="label"
            className="font-weight-bold"
            size="md"
            iconStart={<CurrencyIconMD />}
          >
            {translator.t("!footer.currency-selector")}
            <span className="font-weight-normal before:content-['\00A0\00A0\2014\00A0\00A0']">
              {intlProvider.currency}
            </span>
          </Label>
        }
      >
        {sorted_currencies.map(currency_code => (
          <option key={currency_code} value={makeLink(currency_code)}>
            {currency_code}
          </option>
        ))}
      </CustomNativeSelect>
    </div>
  );
};
